// en-US.ts

export default {
  // Customer Service Center
  'customerServiceCenter': 'Customer Service Center',
  'viewMore': 'View More',

  // Contact Information
  'sendUsAnEmail': 'Send Us an Email',
  'callUs': 'Call Us',
  'globalFreePhone': 'Global Toll-Free Phone',
  'localFreePhone': 'Local Toll-Free Phone',
  'ExclusiveCustomerManager': 'Exclusive Customer Service Manager',
     "phone_label": "Phone Number",
    "email_label": "Email",
    "whatsapp_label": "WhatsApp",
    "telegram_label": "Telegram",
};
